import React, { FunctionComponent, useState, useEffect } from "react";
import { Grid, Typography } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import { useCurrencyStyles } from "./useCurrencyStyles";
import { CurrencyTable } from "./CurrencyView/CurrencyTable";
import { Helmet } from "react-helmet-async";
import { useStore } from "../../store";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
type permissionType = {
  permission_id: number;
  is_view: boolean;
};
export const TabPanel: FunctionComponent<TabPanelProps> = ({
  children,
  value,
  index,
}) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      //   {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};
export const CurrencyMaster = () => {
  const classes = useCurrencyStyles();
  const [value, setValue] = React.useState(0);

  const [viewCurrencyPermission, setViewCurrencyPermission] = useState<boolean>(
    false
  );

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };
  const [currencyList] = useStore("currency");
  const [user] = useStore("auth", "user");

  useEffect(() => {
    const currencyPermission = user.permissions.find(
      (permission: permissionType) => permission.permission_id === 23
    );
    if (user.is_super_admin === true) {
      setViewCurrencyPermission(true);
    } else {
      if (currencyPermission) {
        if (currencyPermission.is_view === true) {
          setViewCurrencyPermission(true);
        } else {
          setValue(1);
          setViewCurrencyPermission(false);
        }
      }
    }
  });
  return (
    <>
      <Helmet>
        <title>Currency</title>
      </Helmet>
      <Grid
        container
        spacing={2}
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Grid item xs={12} className={classes.root}>
          <AppBar position="static">
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="simple tabs example"
            >
              <Tab
                label="Currency List"
                style={{ display: viewCurrencyPermission ? "" : "none" }}
              />
            </Tabs>
          </AppBar>
          <TabPanel value={value} index={0}>
            <Grid
              container
              spacing={2}
              direction="row"
              justify="space-between"
              alignItems="center"
            >
              {viewCurrencyPermission ? (
                <Grid item xs={12}>
                  <CurrencyTable currencylist={currencyList} />
                </Grid>
              ) : null}
            </Grid>
          </TabPanel>
        </Grid>
      </Grid>
    </>
  );
};
